import { FC, useEffect, useState, useRef, useMemo } from 'react';
import { Spin } from 'antd';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import { getChancePointDetail } from '@/common/api/expandStore/chancepoint';
import { getTaskInfo } from '@/common/api/expandStore/expansiontask';
import { tenantCheck } from '@/common/api/common';
import { userPermissionList } from '@/common/api/permission';
import { getApprovalDetail, approvalFormDetail, getShopEditApprovalSnapshot } from '@/common/api/expandStore/approveworkbench';
import { getShopDetail } from '@/common/api/expandStore/shop';
import { getPlanSpotDetail } from '@/common/api/expandStore/planspot';
import { getClusterDetail } from '@/common/api/networkplan';
import { getDetail as getPlanSpotRelationDetail } from '@/common/api/sitemapgather';
import styles from './index.module.less';
import {
  ApprovalType,
  ApprovalTypeValue,
  ApprovePermission,
  IS_DETAIL_EDIT_CHANCE,
  isAreaProtectionApproval,
} from '@/common/components/business/ExpandStore/ts-config';
import { refactorPermissions } from '@lhb/func';
import DetailModules from '@/common/components/business/ExpandStore/ChanceDetailDrawer/components/DetailModules';
import TaskDetail from '@/common/components/business/ExpandStore/TaskDeatil';
import CircleTaskDetail from '@/common/components/business/ExpandStore/CircleTaskDetail';
import SemirTaskDetail from '@/views/expandstore/pages/expansioncirclesenmatask/components/Detail/components/CircleTaskDetail';
import ChanceCreateDrawer from '@/common/components/business/ExpandStore/ChanceCreateDrawer';
import GatherClientDetail from '@/common/components/business/AreaDetailDrawer/components/FirstScreenRight/components/PlanSpotDetail';
import PlanSpotDetail from '@/common/components/business/ExpandStore/PlanSpotDetail';
import ShopDetail from '@/views/expandstore/pages/shopDetail/components/DetailMain';
import EnterDrawer from '@/views/recommend/pages/collectmap/RightCon/EnterDrawer';
import FranchiseeCircleTask from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail/components/DetailMain';
import AreaProtection from '@/common/components/business/AreaProtection';
import Footer from './Footer';
import ModelCluster from './components/ModelCluster';
import Header from './components/Header';
import { getCircleTaskDetail } from '@/common/api/expandStore/expansionCircleTask';
import { buildTaskTerminateInfoDetail } from '@/common/components/business/ExpandStore/TaskTerminateInfo/config';
import AreaProtectionApprovalDetail from './components/AreaProtectionApprovalDetail';
import MallDecisionReportDrawer from '@/common/components/business/ExpandStore/ChanceDetailDrawer/MallDecisionReport';

/**
 * @Description 审批详情抽屉
 * 1109 -标准版数据迁移引用该组件，添加参数 hideOperate 隐藏审批相关按钮
 */
const DetailDrawer: FC<{
  id?: number; // 审批id
  open: boolean; // 是否打开抽屉
  setOpen: Function; // 设置是否打开抽屉
  onRefresh?: Function; // 刷新列表
  hideOperate?: boolean // 隐藏审批相关的按钮
}> = ({
  id,
  open,
  setOpen,
  onRefresh,
  hideOperate = false
}) => {
  const chanceFormRef = useRef(null);
  const titleHeightRef = useRef(0);
  const taskRef = useRef(null);
  const scrollContainerRef: any = useRef();

  const [mainHeight, setMainHeight] = useState<number>(0);
  const [aprDetail, setAprDetail] = useState<any>({}); // 审批详情
  const [ponitDetail, setPointDetail] = useState<any>(); // 点位详情
  const [taskDetail, setTaskDetail] = useState<any>(); // 任务详情
  const [planSpotDetail, setPlanSpotDetail] = useState<any>(); // 集客点详情
  const [shopDetail, setShopDetail] = useState<any>({}); // 机会点签约门店详情
  const [shopEditApprovalFieldChanges, setShopEditApprovalFieldChanges] = useState<any[]>([]); // 门店编辑审批字段变更
  const [isAreaProtect, setIsAreaProtect] = useState<boolean>(false); // 区域保护详情
  const [areaProtectionApprovalDetail, setAreaProtectionApprovalDetail] = useState<any>(); // 防撞店特殊申请关联的机会点详情
  const [saasDecisionPermission, setSaasDecisionPermission] = useState<{ enCode: string; name: string }>(); // 商圈决策报告权限
  const [saasDecisionVisible, setSaasDecisionVisible] = useState<boolean>(false); // 商圈决策报告抽屉

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingTip, setLoadingTip] = useState<string>('');
  const [chanceCreateDrawer, setChanceCreateDrawer] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  });
  const [refreshDetail, setRefreshDetail] = useState<number>(0);
  const [hintStr, setHintStr] = useState<string>('');
  const [hasEditableProperty, setHasEditableProperty] = useState<boolean>(false);

  const [planSpotOpen, setPlanSpotOpen] = useState({
    visible: false,
    value: null
  });// 维护表单抽屉开关及详情数据
  const [taskTemplateCode, setTaskTemplateCode] = useState<string>('');


  /**
   * @description 是否可编辑机会点表单
   * @return 启用编辑机会点，类型为机会点评估，同时具备编辑、通过权限
   */
  const canEditForm = useMemo(() => {
    const { permissions, typeValue } = aprDetail || {};
    if (hideOperate || !IS_DETAIL_EDIT_CHANCE || ![ApprovalTypeValue.ChancePointEvaluate, ApprovalTypeValue.ShopEvaluation].includes(typeValue)) return false;

    const editTarget = permissions.find((itm: any) => itm.event === ApprovePermission.Edit); // 编辑权限
    const approveTarget = permissions.find((itm: any) => itm.event === ApprovePermission.Approve); // 通过权限
    const rebootTarget = permissions.find((itm: any) => itm.event === ApprovePermission.Reboot); // 重新提交权限
    // 添加了重新提交按钮权限的判断
    return !!editTarget && (!!approveTarget || !!rebootTarget);
  }, [aprDetail]);

  /**
   * @description 展示的权限按钮
   * @return 如果可以编辑机会点表单，将edit权限替换为保存按钮
   */
  const showPermissions = useMemo(() => {
    // console.log('useMemo showPermissions', aprDetail, hasEditableProperty);
    let refactorPerms = refactorPermissions(aprDetail.permissions);
    if (canEditForm) {
      // 如果可以页面内直接编辑表单
      if (hasEditableProperty) {
        // 有可编辑项目，将edit权限替换为保存按钮
        refactorPerms = refactorPerms.map((itm: any) =>
          itm.event === ApprovePermission.Edit ? { ...itm, name: '保存' } : itm
        );
      } else {
        // 无可编辑项目，去掉edit权限按钮
        refactorPerms = refactorPerms.filter((itm: any) => itm.event !== ApprovePermission.Edit);
      }
    }
    return refactorPerms;
  }, [aprDetail, hasEditableProperty]);

  const taskTerminateInfoDetail = useMemo(() => {
    if (!taskDetail) return taskDetail;
    return buildTaskTerminateInfoDetail(taskDetail, aprDetail);
  }, [taskDetail, aprDetail]);

  useEffect(() => {
    methods.getTaskConfig();
  }, []);

  useEffect(() => {
    if (!ponitDetail) {
      setHasEditableProperty(false);
    }
  }, [ponitDetail]);

  useEffect(() => {
    if (open) {
      methods.getDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, refreshDetail]);

  const methods = useMethods({

    getTaskConfig: async () => {
      const taskConfig = await tenantCheck();
      setTaskTemplateCode(taskConfig?.taskTemplateCode);
    },

    /** 打开详情页时的编辑表单的刷新详情页 */
    updateHandle: () => {
      const curVal = refreshDetail + 1;
      setRefreshDetail(curVal);
    },

    /**
     * @description 获取审批详情、点位详情
     */
    async getDetail() {
      setPointDetail(null);
      setTaskDetail(null);
      setPlanSpotDetail(null);
      setShopDetail({});
      setShopEditApprovalFieldChanges([]);
      setIsAreaProtect(false);
      setAreaProtectionApprovalDetail(null);
      setSaasDecisionPermission(undefined);
      setSaasDecisionVisible(false);
      setLoading(true);

      const data = await getApprovalDetail({ id }).catch(() => {
        setLoading(false);
      }); // 审批详情
      setAprDetail(data || {});
      // 注意:审批详情页请求的机会点详情接口，与机会点详情页不同

      const { type, typeValue, id: approvalId, relationId } = data || {};
      const currentTaskTemplateCode = taskTemplateCode || (await tenantCheck())?.taskTemplateCode || '';
      if (currentTaskTemplateCode && currentTaskTemplateCode !== taskTemplateCode) {
        setTaskTemplateCode(currentTaskTemplateCode);
      }
      /*
        注意:机会点审批详情页请求的审批快照接口；
        店铺评估审批详情页请求的机会点详情接口
      */
      if (type === ApprovalType.ChancePoint) {
        // 机会点审批时请求机会点快照
        const permissionList = await userPermissionList({
          encodeList: ['standardChancePoint:saasDecision'],
        }).catch(() => []);
        const decisionPermission = Array.isArray(permissionList) ? permissionList.find((item: any) =>
          item?.enCode === 'standardChancePoint:saasDecision'
        ) : undefined;
        setSaasDecisionPermission(decisionPermission);
        const detail = await approvalFormDetail({ id: approvalId }).catch(() => {
          setLoading(false);
        });
        // 机会点详情
        setPointDetail(detail);
      } else if (type === ApprovalType.TaskChange) {
        // 拓店任务异动审批，获取任务详情
        const api = ['clusterA', 'clusterB', 'clusterC', 'locxxA'].includes(currentTaskTemplateCode) ? getCircleTaskDetail : getTaskInfo;
        const taskDtl = await api({ id: relationId }).catch(() => {
          setLoading(false);
        });
        // 任务详情
        setTaskDetail(taskDtl);
      } else if (type === ApprovalType.PlanSpot && typeValue === ApprovalTypeValue.PlanSpot) {
        // 集客点详情--网规
        const detail = await getPlanSpotDetail({ id: approvalId }).catch(() => {
          setLoading(false);
        });
        const data = await getClusterDetail({ planClusterId: detail?.planClusterId }).catch(() => {
          setLoading(false);
        });

        // 集客点详情
        setPlanSpotDetail({
          ...detail,
          radius: data?.radius,
          polygon: data?.polygon
        });
      } else if (type === ApprovalType.PlanSpot && typeValue === ApprovalTypeValue.SiteMapGatherClient) {
        // 集客点详情--选址地图
        const detail = await getPlanSpotRelationDetail({ modelClusterId: relationId }).catch(() => {
          setLoading(false);
        });
        // 集客点详情--选址地图
        setPlanSpotDetail(detail);
      } else if (typeValue === ApprovalTypeValue.ShopEditApproval || typeValue === ApprovalTypeValue.ShopStatusChange) {
        const snapshot = await getShopEditApprovalSnapshot({ id: approvalId }).catch(() => {
          setLoading(false);
        });
        const detail = await getShopDetail({ id: snapshot?.shopId }).catch(() => {
          setLoading(false);
        });
        setShopEditApprovalFieldChanges(snapshot?.fieldChanges || []);
        setShopDetail(detail || {});
      } else if (type === ApprovalType.Contract) { // 门店签约审批
        const data = await approvalFormDetail({ id: approvalId }).catch(() => {
          setLoading(false);
        });
        setShopDetail(data);
      } else if (isAreaProtectionApproval(type, typeValue)) {
        // 防撞店特殊申请的机会点 id 固定使用审批关联 id。
        const detail = await getChancePointDetail({ id: relationId }).catch(() => {
          setLoading(false);
        });
        setAreaProtectionApprovalDetail(detail);
      } else if (type === ApprovalType.ShopProtect && typeValue === ApprovalTypeValue.ShopProtect) {
        setIsAreaProtect(true);
      } else if (type === ApprovalType.ShopEvaluation && typeValue === ApprovalTypeValue.ShopEvaluation) {
        // 点位评估详情

        // 检查“点位评估审批流id”，有的话表示机会模板配置的点位评估审批
        const { evaluationFlowId } = data || {};
        if (evaluationFlowId) {
          // 有配置“机会点的点位评估审批流”时，与机会点审批一样处理请求机会点快照
          const detail = await approvalFormDetail({ id: approvalId }).catch(() => {
            setLoading(false);
          });
          // 机会点详情
          setPointDetail(detail);
        } else {
          // 普通的点位评估审批，请求机会点详情
          const detail = await getChancePointDetail({ id: relationId }).catch(() => {
            setLoading(false);
          });
          // 机会点详情
          setPointDetail(detail);
        }
      }
      setLoading(false);
    },

    /** 打开商圈决策报告抽屉 */
    openSaasDecision() {
      setSaasDecisionVisible(true);
    },

    /** 关闭商圈决策报告抽屉 */
    closeSaasDecision() {
      setSaasDecisionVisible(false);
    },

    /** 编辑 */
    handleEdit() {
      const { type, typeValue } = aprDetail;
      // 可在详情页内直接编辑表单时，保存表单；页面内不可编辑时，去编辑页
      if (canEditForm) {
        // 调用保存机会点
        // saveHandle入参分别为needCheck，成功回调
        // 最终方法saveHandle在 src/common/components/business/ExpandStore/ChanceDetailDrawer/Modules/ChanceForm/index.tsx
        (chanceFormRef?.current as any)?.saveChance(true, () => {
          V2Message.success('保存成功');
          onRefresh && onRefresh();
        });
        return;
      }

      // 集客点
      if (type === ApprovalType.PlanSpot && typeValue === ApprovalTypeValue.PlanSpot) {
        setPlanSpotOpen({ visible: true, value: planSpotDetail });
        return;
      }
      setChanceCreateDrawer({
        open: true,
        templateId: ponitDetail?.dynamicRelationId, // 模板id
        id: ponitDetail?.id, // 编辑时的id
      });
    },
    /**
     * @description 集客点编辑成功后刷新当前详情，及外层页面
     */
    handleEditPlanSpotDetailSuccess() {
      onRefresh && onRefresh();
      methods.updateHandle();
    },

    /**
     * @description 刷新组件外处理并关闭抽屉
     * 审批操作后，因为后端的审批状态更新处理较慢，为了获取到最新的审批状态，这里0.5秒后延时关闭
     */
    refreshAndClose() {
      setLoadingTip('审批处理中');
      setLoading(true);
      setTimeout(() => {
        setLoadingTip('');
        setLoading(false);
        onRefresh && onRefresh();
        setOpen(false);
      }, 500);
    },

    renderChildren: () => {
      if (isAreaProtectionApproval(aprDetail?.type, aprDetail?.typeValue)) {
        return <AreaProtectionApprovalDetail
          chancePointDetail={areaProtectionApprovalDetail}
          approvalDetail={aprDetail}
        />;
      }
      // 渲染机会点详情各个模块
      if (ponitDetail) {
        return <DetailModules
          ref={chanceFormRef}
          approvalScrollContainerRef={scrollContainerRef}
          canEditForm={canEditForm}
          // hideOperate={hideOperate}
          isApproval
          approvalId={aprDetail.id}
          detail={ponitDetail}
          titleHeightRef={titleHeightRef}
          // update={updateHandle}
          setHintStr={setHintStr}
          setHasEditableProperty={setHasEditableProperty}
        />;
      }
      // 渲染拓店任务详情
      if (taskDetail) {
        if (['clusterA', 'clusterB'].includes(taskTemplateCode)) {
          return <CircleTaskDetail
            ref={taskRef}
            detail={taskTerminateInfoDetail}
            refresh={() => onRefresh && onRefresh()}
            isApproval
            aprDetail={aprDetail}
          />;
        } else if (taskTemplateCode === 'clusterC') {
          return <SemirTaskDetail
            ref={taskRef}
            detail={taskTerminateInfoDetail}
            refresh={() => onRefresh && onRefresh()}
            isApproval
            aprDetail={aprDetail}
          />;
        } else if (taskTemplateCode === 'standardA') {
          return <TaskDetail
            ref={taskRef}
            detail={taskTerminateInfoDetail}
            refresh={() => onRefresh && onRefresh()}
            isApproval
            aprDetail={aprDetail}
          />;
        } else if (['standardAndClusterA', 'standardAndClusterB'].includes(taskTemplateCode)) {
          return <FranchiseeCircleTask
            ref={taskRef}
            detail={taskTerminateInfoDetail}
            refresh={() => onRefresh && onRefresh()}
            isApproval
            aprDetail={aprDetail}/>;
        } else if (taskTemplateCode === 'locxxA') {
          return <FranchiseeCircleTask
            ref={taskRef}
            detail={taskTerminateInfoDetail}
            refresh={() => onRefresh && onRefresh()}
            isApproval
            aprDetail={aprDetail}
            isLocxx
          />;
        }
      }
      // 渲染集客点审批详情
      if (planSpotDetail) {
        // 集客点-选址
        if (aprDetail?.typeValue === ApprovalTypeValue.SiteMapGatherClient) {
          return <GatherClientDetail
            isApproval
            aprDetail={aprDetail}
            detail={planSpotDetail}
            refresh={() => onRefresh && onRefresh()}
          />;
        } else {
          // 集客店-网规
          return <PlanSpotDetail
            isApproval
            aprDetail={aprDetail}
            detail={planSpotDetail}
            refresh={() => onRefresh && onRefresh()}
          />;
        }
      }
      if (isAreaProtect) {
        return <AreaProtection
          id={id}
          approvalId={aprDetail?.id}
          showHeader={false}
        />;
      }
      if (aprDetail.type === ApprovalType.ModelCluster && aprDetail?.typeValue === ApprovalTypeValue.ModelClusterCreate) {
        // 新增开店区域审批详情
        return <ModelCluster
          modelClusterId={aprDetail?.relationId}
          aprDetail={aprDetail}
        />;
      } else if (aprDetail?.typeValue === ApprovalTypeValue.ShopEditApproval || aprDetail?.typeValue === ApprovalTypeValue.ShopStatusChange) { // 门店编辑审批 || 门店状态变更审批
        // 门店编辑审批展示快照中的待审批值，真实门店数据仍由审批状态控制。
        return <ShopDetail
          detail={shopDetail}
          isApproval={true}
          approvalFieldChanges={shopEditApprovalFieldChanges}
        />;
      } else if (aprDetail.type === ApprovalType.Contract && aprDetail?.typeValue === ApprovalTypeValue.Contract) {
        return <ShopDetail
          detail={shopDetail}
          isApproval={true}
        />;
      }
      return <></>;
    },

  });

  return (
    <V2Drawer
      open={open}
      onClose={() => setOpen(false)}
      className={styles.approveDrawer}
      destroyOnClose
      contentWrapperStyle={hasEditableProperty ? { // 页面内可编辑动态表单时宽度定制，与机会点详情一致
        width: '76%',
        minWidth: '1100px',
        maxWidth: 'none',
      } : {}}
    >
      <>
        <Spin spinning={loading} tip={loadingTip}>
          <V2Container
            style={{ height: '100vh' }}
            emitMainHeight={setMainHeight}
            extraContent={{
              top: <Header
                aprDetail={aprDetail}
                taskDetail={taskDetail}
                planSpotDetail={planSpotDetail}
                taskTemplateCode={taskTemplateCode}
                hintStr={hintStr}
                titleHeightRef={titleHeightRef}
              />,
              bottom: !hideOperate && (Array.isArray(showPermissions) && !!showPermissions.length || !!saasDecisionPermission) ? <Footer
                id={id}
                aprDetail={aprDetail}
                showPermissions={showPermissions}
                saasDecisionPermission={saasDecisionPermission}
                openSaasDecision={methods.openSaasDecision}
                canEditForm={canEditForm}
                taskRef={taskRef}
                chanceFormRef={chanceFormRef}
                handleEdit={methods.handleEdit}
                refreshAndClose={methods.refreshAndClose}
              /> : <></>,
            }}
          >
            <div
              ref={scrollContainerRef}
              className={styles.body}
              style={{
                height: mainHeight || 'auto',
                overflowY: 'auto',
                overflowX: 'hidden',
              }}>
              {methods.renderChildren()}
            </div>
          </V2Container>
        </Spin>

        {/* 审批详情中编辑机会点 */}
        <ChanceCreateDrawer
          drawerData={chanceCreateDrawer}
          onSearch={onRefresh}
          handleEditSuccessed={methods.updateHandle}
          closeHandle={() =>
            setChanceCreateDrawer({
              open: false,
              templateId: '', // 模板id
              id: '', // 编辑时的id
            })
          }
        />
        {/* 商圈决策报告 */}
        <MallDecisionReportDrawer
          chancePointId={aprDetail?.relationId}
          open={open && saasDecisionVisible && !!saasDecisionPermission && aprDetail?.type === ApprovalType.ChancePoint}
          onClose={methods.closeSaasDecision}
        />
        {/* 集客点录入 */}
        <EnterDrawer
          open={planSpotOpen}
          setOpen={setPlanSpotOpen}
          onRefresh={() => methods.handleEditPlanSpotDetailSuccess()}
        />
      </>
    </V2Drawer>
  );
};

export default DetailDrawer;
